const xiandaiyanqing = {
  category: '现代言情',
  categoryId: '13',
  coverList: [
    {
      coverId: 13001,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#ff4242',
        smallTitleColor: '#fff',
        smallTitleBackground: '#C52B27 linear-gradient(5deg, #FF4242 0%, #9B1613 100%)',
        color_mask: '#9B1613',
        font: '布丁体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/1-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13002,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#4B8FB6',
        smallTitleColor: '#fff',
        smallTitleBackground: '#C52B27 linear-gradient(360deg, #4B8FB6 0%, #AA115F 100%)',
        color_mask: '#AA115F',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/2-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13003,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#08B2CC',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(360deg, #36702A 0%, #98AA5A 100%)',
        color_mask: '#36702A',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/3-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13004,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#C33A23',
        smallTitleColor: '#fff',
        smallTitleBackground: '#C52B27 linear-gradient(360deg, #C33A23 0%, #3A5B84 100%)',
        color_mask: '#3A5B84',
        font: '庞门正道标题体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/4-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13005,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#27343C',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(360deg, #4B8FB6 0%, #27343C 7%, #AA115F 100%)',
        color_mask: '#AA115F',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/5-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13006,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#E64A83',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(5deg, #E64A83 0%, #841332 100%)',
        color_mask: '#841332',
        font: '布丁体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/6-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13007,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#2B4094',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(360deg, #2B4094 0%, #98881B 100%)',
        color_mask: '#98881B',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/7-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13008,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#C33A23',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(360deg, #C33A23 0%, #3A5B84 100%)',
        color_mask: '#3A5B84',
        font: '庞门正道标题体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/8-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13009,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#E64A83',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(5deg, #E64A83 0%, #841332 100%)',
        color_mask: '#841332',
        font: '布丁体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/9-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13010,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#2B4094',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(360deg, #2B4094 0%, #98881B 100%)',
        color_mask: '#98881B',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/10-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13011,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#4B8FB6',
        smallTitleColor: '#fff',
        smallTitleBackground: '#C52B27 linear-gradient(360deg, #4B8FB6 0%, #AA115F 100%)',
        color_mask: '#AA115F',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/11-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13012,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#08B2CC',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(360deg, #36702A 0%, #98AA5A 100%)',
        color_mask: '#36702A',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/12-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13013,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#3E455B',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(360deg, #3E455B 0%, #BC2F45 100%)',
        color_mask: '#BC2F45',
        font: '思源宋体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/13-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 13014,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#E64A83',
        smallTitleColor: '#fff',
        smallTitleBackground: 'linear-gradient(5deg, #E64A83 0%, #841332 100%)',
        color_mask: '#841332',
        font: '布丁体',
        fontSize: '55',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://img.midukanshu.com/browser/h5/cover/xiandaiyanqing/14-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
  ],
};

export default xiandaiyanqing;
